import React, { PureComponent } from 'react';
import Modal from 'react-responsive-modal';
import './ExportModal.scss';
import clearName from '../../../../../utils/clearNames';
import { isEmpty } from 'ramda';
import { Observer, GLOBAL_EVENT } from '../../../Observer';

interface stateInterface {
    open: boolean;
    form: { name: string; scale: number; type: string };
}

export class ExportModal extends PureComponent<{}, stateInterface> {
    constructor(props: any) {
        super(props);
        this.state = {
            open: false,
            form: { name: 'default_name', scale: 1, type: 'export' },
        };
    }

    componentDidMount() {
        Observer.on(GLOBAL_EVENT.OPEN_EXPORT_OPTIONS_PC, () => {
            this.setState({
                ...this.state,
                open: true,
            });
        });
    }

    handleName = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                name: clearName(event.target.value),
            },
        });
    };

    handleScale = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (this.state.form.scale > 10) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    scale: 10,
                },
            });
        } else if (this.state.form.scale < -10) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    scale: -10,
                },
            });
        } else {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    scale: Number(event.target.value),
                },
            });
        }
    };

    handleClickOk = () => {
        Observer.emit(GLOBAL_EVENT.IMAGE_DES_SELECTED);
        if (isEmpty(this.state.form.name)) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    name: 'default_name',
                },
            });
        } else {
            // Emitimos el evento para requerir la imágen de canvas.
            // Cuando todo está listo el ./render/RenderScene.ts emite el evento de GLOBAL_EVENT.IMAGE_CANVAS_EXPORTED
            Observer.emit(GLOBAL_EVENT.REQUEST_IMAGE_CANVAS, this.state.form);
            this.handleCloseModal();
        }
    };

    handleCloseModal = () => {
        this.setState({
            ...this.state,
            open: false,
        });
    };

    render() {
        return (
            <Modal
                open={this.state.open}
                onClose={this.handleCloseModal}
                closeOnOverlayClick={false}
                center
                classNames={{ outline: '10px solid red' }}
                styles={{ marginTop: '1000px' }}
            >
                <div id="export-container">
                    <h3 className="noselect">Export options</h3>
                    <div className="noselect export-container--group">
                        <div className="atlasNameForm">
                            <label htmlFor="atlasName">Atlas Name:</label>
                            <br />
                            <input
                                type="text"
                                id="atlasName"
                                onChange={this.handleName}
                                onBlur={this.handleName}
                                value={this.state.form.name}
                            />
                        </div>
                        <div className="atlasScaleForm">
                            <label htmlFor="atlasName">Atlas scale:</label>
                            <input
                                type="number"
                                id="atlasScale"
                                min={1}
                                max={10}
                                onChange={this.handleScale}
                                onBlur={this.handleScale}
                                value={this.state.form.scale}
                            />
                        </div>
                        <div className="exportButtonsForm">
                            <button onClick={this.handleCloseModal}>Cancel</button>
                            <button onClick={this.handleClickOk}>Ok</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ExportModal;
